import { render } from "./customerlist.vue?vue&type=template&id=140ba32b"
import script from "./customerlist.vue?vue&type=script&lang=js"
export * from "./customerlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__